import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TenantDetailsTable from "./TenantDetailsTable";

const ViewTenantDialog = ({ open, onClose, tenant }) => {
  if (!tenant) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#ffedbb", fontWeight: 600 }}>
        Tenant Details
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[600],
        })}
      >
        <CloseIcon />
      </IconButton>

      <Divider />

      <DialogContent sx={{ backgroundColor: "#f9f9f9" }}>
        <TenantDetailsTable tenant={tenant} />
      </DialogContent>

      <Divider />

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewTenantDialog;
